module.exports = __webpack_public_path__ + "img/menu-hair-4.8d06aec1.jpg";